import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { DevelopmentHelpers } from '../../shared/utilities/developHelpers';
import { AddressSupport } from './addressFunctions';
import { Htmls } from '../../shared/utilities/shared.functions';


@Component({
  selector: 'company-customer-address',
  templateUrl: './company-customer-address.component.html',
  styleUrls: ['./company-customer-address.component.css']
})
export class CompanyCustomerAddressComponent implements OnInit, OnChanges {
  @Input() id: string;
  @Output() idChange = new EventEmitter<string>();
  @Output() update = new EventEmitter<boolean>();
  @Input() isCompany: boolean = false;
  @Input() hideEdit:boolean = false;

  @Input() options: CompanyCustomerAddressOptions = new CompanyCustomerAddressOptions();
  addressFunctions = new AddressSupport(this.http)
  help = new DevelopmentHelpers();

  addresses;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!!changes.id && !!changes.id.currentValue) this.getClientFromId();
  }

  getClientFromId(){
    switch(this.isCompany) {
      case true : {
        this.addressFunctions.getCompanyAddress(this.id).subscribe(
          (data)=> {this.addresses = data;}
        )
        // need a getCompany data call
        break
      }
      case false : {
        // get customer
        this.addressFunctions.getCustomerAddress(this.id).subscribe(
          (data)=> {this.addresses = data;}
        )
        break
      }
    }
  }

  getCardWidth(){
    let t = 'calc(' + (100 / this.options.cardsPerLine) + '% - ' + ((this.options.cardsPerLine - 1) * 0.3) + 'rem)';
    return t
  }

  changeId(id:string){ 
    this.idChange.emit(id);
    this.update.emit(true);
  }

  pickPartner(ev: Event){
    let a = ev.target as HTMLElement;
    if(!a.classList.contains('partnerAddress')){
      a = Htmls.findParentByClass(a,'partnerAddress') as HTMLElement;
    }
    let b = a.parentElement.getElementsByClassName('partnerPickerButton')[0] as HTMLButtonElement;
    b.click();
  }
}

class CompanyCustomerAddressOptions {
  hideDelivery: boolean = false;
  hideContact: boolean = false;
  cardsPerLine: number = 4;
  useNotification: boolean = false;
  editable: boolean = false;
}